const state = {
  token: '',
  tokenTime: 0,
  code: '',
  userInfo: {
    accountNo: '',
    amount: '',
    mobile: '',
    amountExp: ''
  },
  couponId: [],
};

const getters = {
  sAccount: state => {
    return state.userInfo.accountNo;
  },
  couponId: state => {
    return state.couponId;
  },
  sBalance: state => {
    return state.userInfo.amount;;
  },
  sAmountExp: state => {
    return state.userInfo.amountExp;;
  },
  sToken: state => {
    let token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
    return state.token;
  },
  sTokenTime: state => {
    let tokenTime = localStorage.getItem('tokenTime') ? localStorage.getItem('tokenTime') : '';
    return state.tokenTime;
  },
  sCode: state => {
    return state.code;
  },
  sUserInfo: state => {
    return state.userInfo;
  }
};

const mutations = {
  sSetToken(state, token) {
    localStorage.setItem('token', token);
    state.token = token
  },
  sSetCouponId(state, couponId) {
    if(state.couponId){
      let isFind = state.couponId.find(item => item == couponId)
      if (!isFind) {
        state.couponId.push(couponId)
        // console.log(state.couponId,'卡券ID',isFind,couponId);
      }
    }
  },
  clearCouponId(state){
    state.couponId =[]
  },
  sSetTokenTime(state, tokenTime) {
    localStorage.setItem('tokenTime', tokenTime);
    state.tokenTime = tokenTime
  },
  sSetUserInfo(state, userInfo) {
    let id = userInfo.id
    if (!id) {
      userInfo.id = state.userInfo.id
    }
    state.userInfo = userInfo
  },
  sSetPhone(state, phone) {
    state.userInfo.mobile = phone;
  },
  sRemovePhone(state) {
    state.userInfo.mobile = '';
  },
  sSetCode(state, code) {
    state.code = code;
  }
};

const actions = {

};

export default {
  state,
  getters,
  mutations,
  actions
};

